module.exports = __webpack_public_path__ + "static/img/banner1.78a0de8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index/banner1.jpg
// module id = hb9j
// module chunks = 1